export default "__VITE_ASSET__CVNqP7jQ__"